// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3Z7_t","title":"ClientInsurance_title__79ahN","itemText":"ClientInsurance_itemText__ia4vq"};